
export default {
  name: 'SpecialistIntro'
}
